import { useAuthorization } from '@/authorization';

function normalizePermission(permission: string): string {
  return permission.trim().toUpperCase();
}

export function hasNavigationPermission(
  permission: string | undefined,
  permissionTokens: string[] = [],
): boolean {
  if (!permission) {
    return true;
  }

  const normalizedPermission = normalizePermission(permission);
  const normalizedTokens = new Set(permissionTokens.map(normalizePermission));

  if (normalizedTokens.has('*')) {
    return true;
  }

  return normalizedTokens.has(normalizedPermission);
}

export function useNavigationPermission(
  permission: string | undefined,
): boolean {
  const { hasPermission } = useAuthorization();

  if (!permission) {
    return true;
  }

  return hasPermission(permission);
}
